"use client";

import { useSyncExternalStore } from "react";

/** No client store to watch — the value only differs between server and client. */
function subscribe(): () => void {
  return () => {};
}

const getClientSnapshot = () => true;
const getServerSnapshot = () => false;

/**
 * `false` on the server and during hydration, `true` from the first client
 * render onwards.
 *
 * Replaces the `useState(false)` + `useEffect(() => setMounted(true))` pattern:
 * same result, no cascading render, and React switches the snapshot as part of
 * hydration instead of after an extra commit.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
}
